import { format } from 'date-fns';

export const formatCreatedDate = (createdAt?: string): string => {
    if (!createdAt) return '';
    try {
        return format(new Date(createdAt), 'MMM d, yyyy');
    } catch {
        return '';
    }
};
